import React from 'react';

import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';
import type { MenuItem } from '@atlaskit/editor-common/extensions';
import { getQuickInsertMenuItemParents } from '@atlaskit/editor-common/quick-insert/get-menu-item-parents';
import { EXTENSION_ITEM_RANK } from '@atlaskit/editor-common/quick-insert/rank';
import type { PublicPluginAPI } from '@atlaskit/editor-common/types';
import type { ExtensionPlugin } from '@atlaskit/editor-plugins/extension';
import type { RegisterMenuItem } from '@atlaskit/editor-ui-control-model/types';

import { ExtensionQuickInsertMenuItem } from './ExtensionQuickInsertMenuItem';

export const getExtensionQuickInsertComponents = ({
	apiRef,
	createAnalyticsEvent,
	items,
}: {
	apiRef: React.MutableRefObject<PublicPluginAPI<[ExtensionPlugin]> | undefined>;
	createAnalyticsEvent?: CreateUIAnalyticsEvent;
	items: MenuItem[];
}): RegisterMenuItem[] =>
	items.map((item, index) => {
		return {
			type: 'menu-item',
			key: item.key,
			parents: getQuickInsertMenuItemParents({
				categories: item.categories,
				rank: EXTENSION_ITEM_RANK + (item.priority ?? index),
			}),
			component: (props) => {
				const onInsert =
					typeof props.onInsert === 'function' ? (props.onInsert as () => void) : undefined;
				return (
					<ExtensionQuickInsertMenuItem
						apiRef={apiRef}
						createAnalyticsEvent={createAnalyticsEvent}
						item={item}
						onInsert={onInsert}
					/>
				);
			},
		};
	});
